import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventSocketService } from 'src/app/events/services/event-socket.service';
import { EventService } from 'src/app/events/services/event.service';
import { GridComponent } from '../grid/grid.component';
import { GridItem, ScreenView, Operation, StructureGrid, UnitItem } from '../models/interfaces';
import { LayersService } from '../services/layers.service';
import { MultiviewService } from '../services/multiview.service';
import { Title } from '@angular/platform-browser';
import {MenuItem} from 'primeng-lts/api';
import { MultimediaService } from '../services/multimedia.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { MinimapService } from '../services/minimap.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
@Component({
  selector: 'app-screen-view',
  templateUrl: './screen-view.component.html',
  styleUrls: ['./screen-view.component.scss']
})
export class ScreenViewComponent implements OnInit, AfterViewInit {
  configName = "";
  screenView!: ScreenView;
  gridItems: GridItem[] = [];
  auxGridItems: GridItem[] = [];
  //items: UnitItem[] = [];
  structures: StructureGrid[] = [];
  show_not_found = false;
  itemsMenu: MenuItem[]=[];

  unitItems: UnitItem[] = [];
  operations: Operation[] = [];
  private dataSubscription?: Subscription;
  private operationsSubscription?: Subscription;

  wasChanged = false;
  showAddNewView = false;
  //--------- save AS ----------
  showSaveAs = false;
  newName = "";
  validName = false;
  loading = false;

  showScreenRecorder = false;

  mostrarDetalles = false; // activar slider
  showNewViewDialog = false;

  @ViewChild('_gridChild') gridChild!: GridComponent;
  @ViewChild('gridDiv') gridDivs!: ElementRef;
  @ViewChild('nameInput') nameInput!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    public multiviewService: MultiviewService,
    private layersService: LayersService,
    private eventService: EventService,
    private eventSocketService: EventSocketService,
    private titleService: Title,
    ) { }
  ngOnInit() : void{
    this.layersService.initializeServices();
    this.eventService.getAll();
    this.eventSocketService.listen();
    console.log(this.multiviewService.userMultiview, "vistas en el servicio")
    this.itemsMenu = [
      {
        id: '0-vehicles',
        label: 'Vehículos en mapa',
        icon: 'pi pi-fw pi-map-marker',
        command: () => {
          this.mostrarDetalles = !this.mostrarDetalles;
        },
      },
      {
        id: 'a-edit_view',
        label: 'Editar multipantalla',
        icon: 'pi pi-fw pi-th-large',
        command: () => {
          this.showNewViewDialog = true;
        },
      }
    ];
  }

  onHiddenNewViewDialog() {
    this.showNewViewDialog = false
  }
  ngAfterViewInit(): void {
    // Obtiene el parámetro configId de la URL
    let unitItemSaved : UnitItem[]= []
    this.route.params.subscribe(params => {
      this.configName = params['name'];
      console.log("configName: ",this.configName);
      try {
        this.screenView = this.multiviewService.getMultiviewFromLocalStorage(this.configName)[0] as ScreenView;
        console.log("this.screenView: ",this.screenView);
        if(this.screenView.is_group){
          this.gridItems = this.groupedMultiview(this.screenView.grids! as GridItem[],this.screenView.title_group??'')
        }else{
          this.gridItems = this.screenView.grids! as GridItem[];
        }
        console.log("this.gridItems: ", this.gridItems);
        this.titleService.setTitle(this.configName.toUpperCase()+' - GL Tracker');
        for (let item of this.gridItems) {
          //this.items.push(item.content!);
          this.structures.push(item.structure!);
          if(item.content){
            unitItemSaved.push(item.content)
          }
        }
        this.updateGridItems();
      } catch (error) {
        this.show_not_found = true;
        console.log(error);
      }
    });
    this.multiviewService.selectedUnits = unitItemSaved;

  }

  isValidGroupName(){
    if(this.newName.length < 3 || this.newName.includes(' ')){
      this.validName = false;
      this.nameInput.nativeElement.classList.remove('ng-valid');
      this.nameInput.nativeElement.classList.add('ng-invalid','ng-dirty');
    }
    else{
      this.validName = true;
      this.nameInput.nativeElement.classList.remove('ng-invalid','ng-dirty');
      this.nameInput.nativeElement.classList.add('ng-valid');
    }
  }

  recordingStatus(event: boolean){
    console.log("esta grabando?: ", event);
  }

  setGritItems(){
    if(this.gridItems && this.gridItems.length>0){
      this.gridChild.setItems(this.gridItems);
      this.auxGridItems = [...this.gridItems];
      this.auxGridItems.unshift({
        structure: {row:0,col:0,span:0,gridItem_id:"Todo"},
        content_type: 'minimap',
        label: 'Todo',
        show_only_label:false
      });
    }
  }

  async updateGridItems(){
    //this.structures = this.multiviewService.calculateStructure(this.structures);
    for await (const item of this.gridItems) {
      item.structure = this.structures.find(st => st.gridItem_id == item.label)!;
      item.content_type = "minimap";
      item.show_only_label = false;
    }
    this.setGritItems();
  }

  updateGridStructureInChild(){
    this.gridChild.updateStructure(this.structures);
    this.wasChanged = true;
    if(this.configName !== "default"){
      this.itemsMenu.find(item => item.id! == '1')!.disabled = false;
    }
    console.log("wasChanged: ",this.wasChanged);
  }

  onExchange(event: any){
    const { current_item: current, exchanged_item: exchanged }  = event;
    this.structures = this.multiviewService.calculateStructure(this.multiviewService.exchangeItems(this.structures,current,exchanged));
    this.updateGridStructureInChild();
  }
  deleteView(idContainer: string){
    console.log("screen view load", this.structures, idContainer)
    console.log("screen view load selected units", this.multiviewService.selectedUnits)
    this.multiviewService.selectedUnits = this.multiviewService.selectedUnits
      .filter(unit => unit.nombre != idContainer);

    this.structures = this.structures.filter(st => st.gridItem_id !== idContainer);
    this.structures = this.multiviewService.calculateStructure(this.structures);
    this.auxGridItems = this.auxGridItems.filter(item => item.structure!.gridItem_id != idContainer);
    this.updateGridStructureInChild();
  }

  closeScreenRecorder(){
    this.showScreenRecorder = false;
  }

  saveGridChanges(){
    if(this.screenView.name == "screen_default"){
      this.showSaveAs = true;
      this.newName = "";
      return;
    }
    this.loading = true
    console.log("presave: ", this.screenView.grids);
    this.screenView.grids = this.gridChild.items;
    console.log("post save: ", this.screenView.grids);
    console.log("guardando...");
    this.multiviewService.saveMultiview(this.screenView).subscribe(resp => {
      if(resp.success){
        this.wasChanged = false;
        this.loading = false;
        if(this.configName !== "default"){
          this.itemsMenu.find(item => item.id! == '1')!.disabled = true;
        }
        Swal.fire(
          {
            title: 'Guardado',
            text: 'Los datos se guardaron correctamente!!',
            icon: 'success',
            target:'body',
            heightAuto: false
          }
        );
      }else{
        Swal.fire({
          title: 'Error',
          text: 'No se pudo guardar el grupo. Intente nuevamente.',
          icon: 'error',
          target:'body',
          heightAuto: false
        });
      }
    })
  }
  saveAsGrid(){
    this.isValidGroupName();
    if(!this.validName){
      console.log("no tiene nombre valido");
      return;
    }
    console.log("presave: ", this.screenView.grids);
    this.screenView.grids = this.gridChild.items;
    console.log("post save: ", this.screenView.grids);

    this.loading = true;
    //this.screenView.name = this.newName;
    if(this.multiviewService.userMultiview.find(item => item.name == this.newName)){
      // Si hay un multiview que se llame igual preguntar si sobreescribirá;
      console.log("duplicated?: ", this.multiviewService.userMultiview);
      Swal.fire({
        title: '¿Sobreescribir grupo?',
        text: `¿El grupo ${this.newName} ya existe, desea sobreecribirlo?`,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Sobreescribir',
        cancelButtonText: 'Cancelar',
        heightAuto: false,
        allowOutsideClick: () => !Swal.isLoading(), // Evita interacción externa mientras se carga
        preConfirm: async () => {
          try {
            const resp = await this.multiviewService.saveMultiview(this.screenView,this.newName).toPromise();
            if (resp.success) {
              this.wasChanged = false;
              this.showSaveAs = false
              if(this.configName === "default"){
                this.itemsMenu.find(item => item.id! == '1')!.disabled = true;
              }
              this.loading = false;
              Swal.fire(
                {
                  title: 'Guardado',
                  text: 'Los datos se guardaron correctamente!!',
                  icon: 'success',
                  target:'body',
                  heightAuto: false
                }
              );
            } else {
              this.loading = false;
              Swal.fire({
                title: 'Error',
                text: 'No se pudo guardar los datos.',
                icon: 'error',
                target:'body',
                heightAuto: false
              });
            }
          } catch (error) {
            this.loading = false;
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error en la solicitud.',
              icon: 'error',
              target:'body',
              heightAuto: false
            });
          }
        },
      }).then((result) => {
        if (result.isDismissed) {
          this.screenView.was_edited = true;
          this.loading = false;
        }
      });;
    }else{
      this.loading = true;
      this.multiviewService.saveMultiview(this.screenView, this.newName).subscribe(resp => {
        if(resp.success){
          console.log("current userMultiviews: ",this.multiviewService.userMultiview);
          this.wasChanged = false;
          this.showSaveAs = false;
          if(this.configName === "default"){
            this.itemsMenu.find(item => item.id! == '1')!.disabled = true;
          }
          Swal.fire(
            {
              title: 'Guardado',
              text: 'Los datos se guardaron correctamente!!',
              icon: 'success',
              target:'body',
              heightAuto: false
            }
          );
        }else{
          Swal.fire({
            title: 'Error',
            text: 'No se pudo guardar el grupo. Intente nuevamente.',
            icon: 'error',
            target:'body',
            heightAuto: false
          });
        }
        this.loading = false;
      });
    }
  }  
  groupedMultiview(arrayGrid:GridItem[],title:string):GridItem[]{
    let arrayImeis:string[] = [];

    const defaultStructureGrid: StructureGrid = {row: 1,col: 1,span: 1,gridItem_id: "GroupedDefault"};

    for (const grid of arrayGrid) {
      arrayImeis.push(grid.content?.imeis[0] as string);
    }

    const groupGrid: GridItem[] = [
      {
        structure: defaultStructureGrid, // Uso de la estructura predefinida
        content: {
          nombre: 'Unidades en Conjunto',
          type: 'convoy',
          imeis: arrayImeis,
        },
        content_type: 'minimap',
        label: "GroupedDefault",
        title: title,
        show_only_label: true,
      }
    ];
    return groupGrid;
  }

  onCloseMapSlider(event : boolean) {
    this.mostrarDetalles = !event;
  }
}
